// import external dependencies
import "jquery";

// Import everything from autoload
;

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import footer from "./routes/footer";
import home from "./routes/home";
import aboutUs from "./routes/about";
import slick from "./routes/slick";
import slider from "./routes/slider";
import frame from "./routes/frame";

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Footer
  footer,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Slick
  slick,
  // Slider
  slider,
  // Select
  frame,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js